import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const searchAttributes = [
  { field: 'title', weight: 100 },
  { field: 'summary', weight: 1 },
  { field: 'description', weight: 1 },
  'field_paragraphs_field_body',
  'field_paragraphs_field_title',
  'faq_question',
  'faq_answer',
];

export const resultAttributes = [
  'url',
  'combined_types',
  'type',
  'title',
  'summary',
  'image_style_uri',
  'field_type_of_information_name',
  'theme',
  'description',
  'entity_type',
  'field_publication_date',
];

export const facetAttributes: SearchkitWrapperProps['searchSettings']['facet_attributes'] = [
  {
    attribute: 'subject',
    field: 'field_subject_name',
    type: 'string',
  },
  {
    attribute: 'workfield',
    field: 'field_workfield_name',
    type: 'string',
  },
  {
    attribute: 'pillar',
    field: 'pillar',
    type: 'string',
  },
  {
    attribute: 'type',
    field: 'type',
    type: 'string',
  },
  {
    attribute: 'combinedTypes',
    field: 'combined_types',
    type: 'string',
  },
  {
    attribute: 'field_phase_of_life_name',
    field: 'field_phase_of_life_name',
    type: 'string',
  },
  {
    attribute: 'field_locations_name',
    field: 'field_locations_name',
    type: 'string',
  },
  {
    attribute: 'theme',
    field: 'theme',
    type: 'string',
  },
];
